'use strict';

import { init as callAjax } from './contentModalAjax';

$(() => {
    const modal = $('.js-contentModal');

    $('body').on('shown.bs.modal', '.js-contentModal', function (e) {
        const ariaLabelledbyID = $(e.relatedTarget).attr('id');
        const modalHref = $(e.relatedTarget).data('modal-href');
        const modalContentId = $(e.relatedTarget).data('modal-content-id');
        
        document.querySelector('.js-contentModal').setAttribute('aria-labelledby', ariaLabelledbyID);

        let selectedUrl = '';

        if (modalHref) {
            selectedUrl = modalHref;
        } else {
            selectedUrl = `${window.spsDataLayer.endpoints.endpointPageShowCid}${modalContentId}`;
        }

        callAjax(selectedUrl);
    });
});